import { NgModule } from '@angular/core';
import { PreloadingStrategy, Route, RouterModule, Routes } from '@angular/router';
import { Observable, of } from 'rxjs';
import { appRedirectGuard } from './core/guards/app-routing-guard/app-redirect.guard';

class SelectivePreloadingStrategy implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        // Only preload routes marked for preloading
        return route.data?.['preload'] ? load() : of(null);
    }
}

const routes: Routes = [
    {
        path: '',
        canActivate: [appRedirectGuard],
        data: {
            title: 'Virtual Card PIN OTP',
            preload: false,
        },
        loadChildren: () => import('./pages/wallet-pin-otp/wallet-pin-otp.module').then((m) => m.WalletPinOtpModule),
    },
    {
        path: 'pin-creation',
        canActivate: [appRedirectGuard],
        data: {
            title: 'Virtual Card PIN Creation',
            preload: true,
        },
        loadChildren: () =>
            import('./pages/wallet-pin-creation/wallet-pin-creation.module').then((m) => m.WalletPinCreationModule),
    },
    {
        path: 'access-denied',
        loadComponent: () =>
            import('./shared/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            // Performance optimizations
            enableTracing: false,
            onSameUrlNavigation: 'reload',
            preloadingStrategy: SelectivePreloadingStrategy,
            initialNavigation: 'enabledBlocking',
            scrollPositionRestoration: 'disabled', // Not needed in webview
        }),
    ],
    providers: [SelectivePreloadingStrategy],
    exports: [RouterModule],
})
export class AppRoutingModule {}
